import React, { useState, useEffect, Fragment } from "react";
import {
  Row,
  Col,
  CardBody,
  Label,
  Card,
  FormFeedback,
  Input
} from "reactstrap";
import Select from "react-select";
import i18n from "../../../i18n";
import SimpleAlertError from "../../../components/Alerts/SimpleAlertError";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { getOrgsAdmin } from "../../../helpers/api_rombo_helper";
import { UserType } from "../../../constants/enums";

const Step1 = ({ step, setStep, setName, setPhone, setEmail, name, phone, email, token, setLastName, lastName, setSecondLastName, secondLastName, setCompany, company, setIsRole, isRole, setInfoUser, infoUser }) => {

  const dispatch = useDispatch()
  const [emailValid, setEmailValid] = useState(false);
  const [phoneValid, setPhoneValid] = useState(false);
  const [errorAlert, setErrorAlert] = useState(false);
  const [errorAlertMessage, setErrorAlertMessage] = useState(null);
  const [listCompanies, setListCompanies] = useState([]);
  const [listTypeUser, setTypeUser] = useState([]);

  useEffect(() => {
    onGetOrgsAdmin()
    formatTypeUser()
    fillCompany()
  }, [dispatch]);

  useEffect(() => {
    if (infoUser) {
      formatTypeUser();
    }
  }, [infoUser]);  

  const onGetOrgsAdmin = () => {
    let partnersInfo = [];
    getOrgsAdmin(token)
      .then((response) => {
        response.map((item) => {
          partnersInfo.push({ label: item.name, value: item.partner_id});
        });
        setListCompanies([...partnersInfo]);
      })
      .catch((error) => {
        console.error("Error - onGetOrgsAdmin - ", error);
        setErrorAlert(true);
        setErrorAlertMessage((error?.response?.data?.detail || error.message));
      });
  };
  
  const fillCompany = () => {
    if (!infoUser.is_staff && infoUser.partner_name && infoUser.partner_id) {
      setCompany({ label: infoUser.partner_name, value: infoUser.partner_id });
    }
  };
  
  const formatTypeUser = () => {
    const arr = [];
  
    if (infoUser?.is_staff) {
      arr.push({ label: i18n.t("IsStaff"), value: UserType.STAFF });
    }
    // arr.push({ label: i18n.t("IsUser"), value: UserType.USER })
    arr.push({ label: i18n.t("IsAdmin"), value: UserType.ADMIN });
  
    setTypeUser(arr);
  };  

  const onClickNextStep = () => {
    if (name && email && phone && isRole) {
      setErrorAlertMessage(null);
      setErrorAlert(false);
      setStep(step + 1);
    } else {
      setErrorAlertMessage(i18n.t("PleaseFillAllFields"));
      setErrorAlert(true);
    }
  };  

  const onBlurPhone = (newPhone) => {
    if (!newPhone.match('[0-9]{10}')) {
      setPhoneValid(true);
    } else {
      setPhoneValid(false);
      setPhone(newPhone);
    }
  };
  
  const onBlurEmail = (newEmail) => {
    if (!newEmail.match(/.+@.+\..+/)) {
      setEmailValid(true);
    } else {
      setEmailValid(false);
      setEmail(newEmail);
    }
  };

  return (
    <Fragment>
      <CardBody>
        <SimpleAlertError
          errorAlert={errorAlert}
          setErrorAlert={setErrorAlert}
          text={errorAlertMessage}
        />
        <Row>
          {infoUser.is_staff && ( 
            <Col xxl={6} md={6} xs={12}>
              <h6 className="employees-form-title" htmlFor="companyNameInput">{i18n.t("Partner")}</h6>
              <p className="employees-form-text">{i18n.t("DescSelectPartner")}</p>
              <Card>
                <Select
                  name="company"
                  placeholder={i18n.t("SelectPartnerName")}
                  options={listCompanies}
                  className="select2-selection"
                  value={listCompanies.filter((item) => item.value == company.value )}
                  onChange={(e) => setCompany(e)}
                />
              </Card>
              <div className="request-separator" />
            </Col>
          )}
          <Col xs={12} xxl={12} xl={12} className="pb-3">
            <h6 className="employees-form-title">{i18n.t("DataUser")}</h6>
            <p className="employees-form-text">{i18n.t("DescUser")}</p>
          </Col>
          <Row>
            <Col xs={12} xxl={6} xl={12} className="">
              <Label className="employees-form-subtitle" htmlFor="nameInput">
                {i18n.t("DisplayName")}
              </Label>  
              <Input
                type="text"
                name="name"
                value={name}
                className="employees-form-input"
                id="nameInput"
                onChange={(e) => setName(e.target.value)}
                placeholder={i18n.t("UserName")}
              />
            </Col>
          </Row>
          <Row>
            <Col xs={12} xxl={3} xl={4} className="pt-2">
              <Label className="employees-form-subtitle" htmlFor="emailInput">
                {i18n.t("Email")}
              </Label>  
              <Input
                type="email"
                name="email"
                defaultValue={email}
                className="employees-form-input"
                id="emailInput"
                onBlur={(e) => onBlurEmail(e.target.value)}
                placeholder={i18n.t("UserEmail")}
              />
              {emailValid && (
                <FormFeedback type="invalid" className="error-message">
                  <i className="fa fa-exclamation-circle"></i>
                  {i18n.t("EmailInvalid")}
                </FormFeedback>
              )}
            </Col>
            <Col xs={12} xxl={3} xl={4} className="pt-2">
              <Label className="employees-form-subtitle" htmlFor="phoneInput">
                {i18n.t("Phone")}
              </Label>  
              <Input
                type="text"
                name="phone"
                defaultValue={phone}
                className="employees-form-input"
                id="phoneInput"
                minLength={10}
                maxLength={10}
                onBlur={(e) => onBlurPhone(e.target.value)}
                placeholder={i18n.t("UserPhone")}
              />
              {phoneValid && (
                <FormFeedback type="invalid" className="error-message">
                  <i className="fa fa-exclamation-circle"></i>
                  {i18n.t("PhoneInvalid")}
                </FormFeedback>
              )}
            </Col>
          </Row>
          <Col xxl={12} md={6} xs={12}>
            <div className="request-separator" />
          </Col>
          <Col xxl={12} md={4} xs={4}></Col>
          {infoUser.is_staff && (
            <Col xxl={4} md={4} xs={12} className="pt-2">
              <h6 className="employees-form-title">{i18n.t("TypeUser")}</h6>
              <p className="employees-form-text">{i18n.t("DescTypeUser")}</p>
              <Card>
                <Select
                  name="typeUser"
                  placeholder={i18n.t("NotAssigned")}
                  options={listTypeUser}
                  className="select2-selection"
                  value={listTypeUser.filter((item) => item.value == isRole )}
                  onChange={(e) => setIsRole(e.value)}
                />
              </Card>
            </Col>
          )}
          <Col xxl={12} md={12} xs={12} className="pt-3 d-flex">
            <button onClick={() => onClickNextStep()} className="btn btn-request">
              {i18n.t("NextStep")}
            </button>
            <Link to={"/users"} className="btn btn-go-back mx-2">
              {i18n.t("Back")}
            </Link>
          </Col>
        </Row>
      </CardBody>
    </Fragment>
  )
}

export default Step1;
